<app-header></app-header>
<!-- <div>
    <h1> {{"HELLO" | translate}}</h1>
    <h2>Hola</h2>
</div> -->
<router-outlet></router-outlet>
<app-footer></app-footer>